import React, { useEffect, useState } from 'react';
import EventsSection from '../sections/Events';
import { TTEvent } from '../types';
import Footer from '../sections/Footer';
import { CircleLoader } from 'react-spinners';
import '../App.css'

const Events = () => {
    const [eventsData, setEventsData] = useState<TTEvent[] | null>(null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
          try {
            const TTresponse = await fetch('/api/ticketTailor'); // Adjust the path if needed
            const TTdata = await TTresponse.json();
            //const EBresponse = await fetch('/api/eventbrite');
            //const EBdata = await EBresponse.json();
            setEventsData(TTdata.data.sort((a: TTEvent, b: TTEvent) => b.created_at - a.created_at));
            setTimeout(() => {
              setLoaded(true);
            }, 1000);
          } catch (error) {
            console.error('Error fetching data:', error);
            setLoaded(true); // Even if there's an error, we mark loaded to avoid infinite loading state
          }
        };

        window.scrollTo({ top: 0 });
      
        fetchData();
      }, []);
      
  return (
    <div>
      {!loaded ? (
        // Display this while data is loading
        <div className="full">
          <CircleLoader color="black" />
        </div>
      ) : (
        // Once loaded, display the events data
        <EventsSection eventsData={eventsData || [{
          "id": "es_1072621",

          "created_at": 1700501081,
          "description": "<p>Labour in the City is delighted to invite you to our Christmas reception to celebrate the network’s achievements in the past year. We will be joined by special guests:</p>\n<ul><li>Alistair Strathern, MP for Mid-Bedfordshire</li><li>Rachel Blake, PPC for Cities of London and Westminster</li><li>Jeevun Sandher, PPC for Loughborough</li></ul>\n<p>We hope you’ll be able to join us. We expect demand for this event to be high so please remember to book early to avoid disappointment and only sign up if you are certain you can attend.</p>",
          "images": {
              "header": "https://uploads.tickettailor.com/c_crop,dpr_1.0,h_406,q_100,w_1280,x_0,y_27/c_scale,g_center,h_373,q_85,w_1172/v1/production/userfiles/jdnvwn2ernacvcfgwt6b.jpg?_a=BAAAV6DQ",
              "thumbnail": "https://uploads.tickettailor.com/c_crop,dpr_1.0,h_245,q_100,w_245,x_16,y_11/c_scale,h_108,q_85,w_108/v1/production/userfiles/jdnvwn2ernacvcfgwt6b.jpg?_a=BAAAV6DQ"
          },
          "name": "Labour in the City Christmas Reception",
          "status": "published",
          "url": "https://buytickets.at/labourinthecity/1072621",
          "venue": {
              "name": "Hanover Communications, London",
              "postal_code": "SE1 9HA"
          },
      }]} />
      ) }
      {loaded && <Footer page='events' />}
    </div>
  );
};

export default Events;
